import { z } from 'zod';
import { ModelCode, ModelCodesSchema } from '@/types/model-code.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { ModelStatus } from '@/types/model/model-status.type.ts';
import { ModelSchema } from '@/types/model/model.type.ts';

export type ModelsPaginatorItem = {
    id: number,
    brand_id: number,
    name: string,
    status: ModelStatus,
    created_at: string,
    model_codes: ModelCode[],
};

export type ModelsPaginator = {
    data: ModelsPaginatorItem[],
    meta: PaginationMeta,
};

export type ModelsRequestFilter = {
    brand_id?: number,
    name?: string,
    status?: ModelStatus[],
    page?: number,
    sort: Record<string, string>[],
};

export const ModelsPaginatorItemSchema = z.object({
    id: z.number(),
    brand_id: z.number(),
    name: z.string(),
    status: z.nativeEnum(ModelStatus),
    created_at: z.string(),
    model_codes: ModelCodesSchema,
});

export const ModelsPaginatorSchema = z.object({
    data: z.array(ModelsPaginatorItemSchema),
    meta: PaginationMetaSchema,
});

export const ModelsSchema = z.array(ModelSchema);
